import { subscribeToNewsletterListsApi } from 'application/repositories/newsletterRepository';

export const subscribeToNewsletterLists = async (
	data: Models.SubscribeToNewsletterLists,
): Promise<Models.SubscribeToNewsletterListsResponse> => {
	return await subscribeToNewsletterListsApi(data).catch((error) => {
		throw error;
	});
};
